import PublicLayout from "../layout/PublicLayout";
import Home from "../Components/Home/home";
import Features from "../Components/Features/features";
import Login from "../Components/Auth/Login/login";
import Register from "../Components/Auth/Register/register";
import AboutUs from "../Components/AboutUS/aboutUs";
import ContactUs from "../Components/ContactUS/contactUs";

const publicRoutes = [
  {
    path: "/",
    element: (
      <PublicLayout>
        <Home />
      </PublicLayout>
    ),
  },
  {
    path: "/features",
    element: (
      <PublicLayout>
        <Features />
      </PublicLayout>
    ),
  },
  {
    path: "/login",
    element: (
      <PublicLayout>
        <Login />
      </PublicLayout>
    ),
  },
  {
    path: "/register",
    element: (
      <PublicLayout>
        <Register />
      </PublicLayout>
    ),
  },
  {
    path: "/AboutUs",
    element: (
      <PublicLayout>
        <AboutUs />
      </PublicLayout>
    ),
  },
  {
    path: "/ContactUs",
    element: (
      <PublicLayout>
        <ContactUs />
      </PublicLayout>
    ),
  },
];

export default publicRoutes;
